// extracted by mini-css-extract-plugin
module.exports = {"Index":"IndexTemplate_Index__5hV3D","Index__BooksArea":"IndexTemplate_Index__BooksArea__E7IGn","Index__BooksContent":"IndexTemplate_Index__BooksContent__MnVLC"};